import React from 'react';
import PropTypes from 'prop-types';

const Project = ({img, flip, children}) => {
  let image = (
    <img src={img} />
  );
  let right = children;
  let left = image;
  if (flip) {
    right = image;
    left = children;
  }
  return (
    <div className='project'>
      <div className={flip ? 'l' : 's'}>{left}</div>
      <div className={flip ? 's' : 'l'}>{right}</div>
    </div>
  );
};

Project.propTypes = {
  flip: PropTypes.bool,
  img: PropTypes.string,
  children: PropTypes.node,
};

export default Project;



// WEBPACK FOOTER //
// ./src/components/project.js